import * as Types from '../Constants/AllConstants';

// 🔹 Fetch All (Paged or Unpaged)
export const MailingListReducer = (state = { lists: [] }, action) => {
  switch (action.type) {
    case Types.MAILING_LIST_REQUEST:
      return { loading: true, lists: [] };
    case Types.MAILING_LIST_SUCCESS:
      return {
        loading: false,
        lists: action.payload.content || action.payload,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.MAILING_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// 🔹 Single Mailing List (details view)
export const MailingListDetailsReducer = (state = { mailingList: {} }, action) => {
  switch (action.type) {
    case Types.MAILING_LIST_DETAILS_REQUEST:
      return { ...state, loading: true };
    case Types.MAILING_LIST_DETAILS_SUCCESS:
      return { loading: false, mailingList: action.payload };
    case Types.MAILING_LIST_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// 🔹 Create Mailing List
export const MailingListCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MAILING_LIST_CREATE_REQUEST:
      return { loading: true };
    case Types.MAILING_LIST_CREATE_SUCCESS:
      return { loading: false, success: true, mailingList: action.payload };
    case Types.MAILING_LIST_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MAILING_LIST_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// 🔹 Update Mailing List
export const MailingListUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MAILING_LIST_UPDATE_REQUEST:
      return { loading: true };
    case Types.MAILING_LIST_UPDATE_SUCCESS:
      return { loading: false, success: true, mailingList: action.payload };
    case Types.MAILING_LIST_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MAILING_LIST_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// 🔹 Delete Mailing List
export const MailingListDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MAILING_LIST_DELETE_REQUEST:
      return { loading: true };
    case Types.MAILING_LIST_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.MAILING_LIST_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MAILING_LIST_DELETE_RESET:
      return {};
    default:
      return state;
  }
};


// 🔹 Fetch Entries by Mailing List
export const MailingEntryReducer = (state = { entries: [] }, action) => {
  switch (action.type) {
    case Types.MAILING_ENTRY_REQUEST:
      return { loading: true, entries: [] };
    case Types.MAILING_ENTRY_SUCCESS:
      return {
        loading: false,
        entries: action.payload.content || action.payload,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.MAILING_ENTRY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// 🔹 Add Entry to Mailing List
export const MailingEntryCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MAILING_ENTRY_CREATE_REQUEST:
      return { loading: true };
    case Types.MAILING_ENTRY_CREATE_SUCCESS:
      return { loading: false, success: true, entry: action.payload };
    case Types.MAILING_ENTRY_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MAILING_ENTRY_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// 🔹 Update Entry in Mailing List
export const MailingEntryUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MAILING_ENTRY_UPDATE_REQUEST:
      return { loading: true };
    case Types.MAILING_ENTRY_UPDATE_SUCCESS:
      return { loading: false, success: true, entry: action.payload };
    case Types.MAILING_ENTRY_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MAILING_ENTRY_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// 🔹 Delete Entry from Mailing List
export const MailingEntryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.MAILING_ENTRY_DELETE_REQUEST:
      return { loading: true };
    case Types.MAILING_ENTRY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.MAILING_ENTRY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.MAILING_ENTRY_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
